import React, { useEffect, useRef, useState } from "react";
import "./Testimonials.css";

const ITEMS = [
  {
    quote:
      "O CEDOC é um programa profundo que cobre minhas necessidades para poder assinar a Declaração de Conformidade.",
    author: "Fernanda Vieira",
    role: "",
  },
  {
    quote:
      "Ganhamos segurança e velocidade nas auditorias. Virou padrão interno.",
    author: "Carla Moreira",
    role: "",
  },
  {
    quote:
      "A busca reduziu horas de trabalho para minutos. Suporte excelente.",
    author: "Rafael Teles",
    role: "",
  },
    {
    quote:
      "Realizei a digitalização e armazenamento dos documentos da minha empresa, é fantástico rápido e seguro",
    author: "Beatriz Maia",
    role: "",
  },
];

export default function Testimonials({ items = ITEMS, autoPlayMs = 7000 }) {
  const [active, setActive] = useState(0);
  const wrapRef = useRef(null);
  const timerRef = useRef(null);

  const go = (i) => setActive((i + items.length) % items.length);
  const next = () => go(active + 1);

  // autoplay com pausa no hover/foco
  useEffect(() => {
    const start = () => {
      clearInterval(timerRef.current);
      timerRef.current = setInterval(next, autoPlayMs);
    };
    const stop = () => clearInterval(timerRef.current);

    start();

    const el = wrapRef.current;
    el?.addEventListener("mouseenter", stop);
    el?.addEventListener("mouseleave", start);
    el?.addEventListener("focusin", stop);
    el?.addEventListener("focusout", start);

    return () => {
      stop();
      el?.removeEventListener("mouseenter", stop);
      el?.removeEventListener("mouseleave", start);
      el?.removeEventListener("focusin", stop);
      el?.removeEventListener("focusout", start);
    };
    // eslint-disable-next-line
  }, [active, autoPlayMs]);

  return (
    <section className="Section Section--testimonials" id="depoimentos">
      <div className="container">
       

        <div
          className="tst-wrap"
          ref={wrapRef}
          role="region"
          aria-roledescription="carousel"
          aria-label="Depoimentos de clientes"
        >
          {items.map((t, i) => (
            <article
              key={i}
              className={`tst-slide ${i === active ? "is-active" : ""}`}
              aria-hidden={i === active ? "false" : "true"}
            >
              <p className="tst-quote">“{t.quote}”</p>
              <p className="tst-author">
                <strong>{t.author}</strong>
                <span>{t.role}</span>
              </p>
            </article>
          ))}

          {/* bolinhas centralizadas */}
          <div className="tst-dots" role="tablist" aria-label="Seleção de depoimento">
            {items.map((_, i) => (
              <button
                key={i}
                role="tab"
                aria-selected={i === active}
                aria-label={`Depoimento ${i + 1}`}
                className={`dot ${i === active ? "active" : ""}`}
                onClick={() => setActive(i)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
